/* @flow */
import * as React from 'react';
import { range } from 'lodash';

import DateConstants from 'constants/DateConstants';
import Select from 'components/Select';

import './styles/BirthdateSelector.scss';

class BirthdateSelector extends React.Component<
  {
    onChange?: Function,
    initialDate?: ?Date,
    disabled?: ?boolean,
  },
  *
> {
  state = {
    year: this.props.initialDate ? this.props.initialDate.getUTCFullYear() : null,
    month: this.props.initialDate ? this.props.initialDate.getUTCMonth() + 1 : null,
    day: this.props.initialDate ? this.props.initialDate.getUTCDate() : null,
  };

  getBirthdate = () => {
    // Setting default values to 0 to satisfy flow typing
    const year = this.state.year || 0;
    const month = this.state.month || 0;
    const day = this.state.day || 0;
    const isValid = year !== 0 && month !== 0 && day !== 0;

    if (isValid) {
      return new Date(year, month - 1, day);
    } else {
      return null;
    }
  };

  calculateBirthdate = () => {
    const date = this.getBirthdate();

    if (date && this.props.onChange) {
      this.props.onChange(date);
    }
  };
  dayChanged = (value: string) => {
    this.setState({ day: parseInt(value, 10) }, this.calculateBirthdate);
  };
  monthChanged = (value: string) => {
    const month = parseInt(value, 10);
    this.setState({ month }, () => {
      // return number of days in a month
      const days = new Date(this.state.year || 0, month, 0).getDate();

      if (this.state.day && this.state.day > days) {
        this.setState({ day: days }, this.calculateBirthdate);
      } else {
        this.calculateBirthdate();
      }
    });
  };
  yearChanged = (value: string) => {
    this.setState({ year: parseInt(value, 10) }, this.calculateBirthdate);
  };
  render() {
    const { disabled } = this.props;

    const monthOptions = range(0, 12).map(n => ({
      label: DateConstants.MONTHS[n],
      value: n + 1,
    }));

    // return number of days in a month
    const days = new Date(this.state.year || 0, this.state.month || 0, 0).getDate();
    const dayOptions = range(1, days + 1).map(n => ({
      label: n,
      value: n,
    }));

    const currentYear = new Date().getFullYear();
    const yearOptions = range(currentYear - 120, currentYear + 1)
      .reverse()
      .map(n => ({
        label: n,
        value: n,
      }));

    return (
      <div className="BirthdateSelector">
        <div className="BirthdateSelector-Select">
          <Select
            className="BirthdateSelector-Select-Month bday-month"
            options={monthOptions}
            autoComplete="bday-month"
            placeholder="Month"
            value={this.state.month}
            onChange={this.monthChanged}
            disabled={!!disabled}
          />
        </div>

        <div className="BirthdateSelector-Select">
          <Select
            options={dayOptions}
            key={this.state.day}
            className="BirthdateSelector-Select-Day bday-day"
            autoComplete="bday-day"
            placeholder="Day"
            value={this.state.day}
            onChange={this.dayChanged}
            disabled={!!disabled}
          />
        </div>

        <div className="BirthdateSelector-Select">
          <Select
            options={yearOptions}
            className="BirthdateSelector-Select-Year bday-year"
            autoComplete="bday-year"
            placeholder="Year"
            value={this.state.year}
            onChange={this.yearChanged}
            disabled={!!disabled}
          />
        </div>
      </div>
    );
  }
}

export default BirthdateSelector;
